module.exports = __webpack_public_path__ + "static/media/pessoas.8f7789a1.png";